module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"Title":"Rapport de vélocité de tout le monde","Velocity":"Vélocité","DisplayName":"Nom","ProjectsInError":"Projets en erreur"}}')
  delete Component.options._Ctor
}
